// Canonical archetype tag enums shared by the FilterPanel and the
// Archetypes browse page. The major archetype is one of three buckets;
// minor archetypes are organised under their parent major so the picker
// can group/disable them appropriately.

export const ARCHETYPE_MAJORS = [
    { id: 'any', label: 'Any' },
    { id: 'midrange', label: 'Midrange' },
    { id: 'control', label: 'Control' },
    { id: 'combo', label: 'Combo' },
];

export const ARCHETYPE_MINORS_BY_MAJOR = {
    midrange: [
        { id: 'midrange', label: 'Midrange' },
        { id: 'COMBAT', label: 'Combat' },
        { id: 'EXTRACOMBAT', label: 'Extra Combats' },
        { id: 'ANTHEM', label: 'Anthem' },
        { id: 'TOKENS', label: 'Tokens' },
        { id: 'EXALTED', label: 'Exalted' },
        { id: 'PLUSONEPLUSONECOUNTERS', label: '+1/+1 Counters' },
        { id: 'BATTLECRUISER', label: 'Battle Cruiser' },
        { id: 'REANIMATOR', label: 'Reanimator' },
        { id: 'VOLTRON', label: 'Voltron' },
        { id: 'POISON', label: 'Poison' },
        { id: 'STOMPY', label: 'Stompy' },
        { id: 'ENCHANTRESS', label: 'Enchantress' },
        { id: 'LANDSMATTER', label: 'Lands Matter' },
        { id: 'GROUPSLUG', label: 'Group Slug' },
        { id: 'KINDRED', label: 'Kindred' },
    ],
    control: [
        { id: 'control', label: 'Control' },
        { id: 'PILLOWFORT', label: 'Pillow Fort' },
        { id: 'COUNTERS', label: 'Counters' },
        { id: 'BOARDWIPES', label: 'Board Wipes' },
        { id: 'MLD', label: 'MLD' },
        { id: 'THEFT', label: 'Theft' },
        { id: 'STAX', label: 'Stax' },
        { id: 'TAXES', label: 'Taxes' },
        { id: 'GOAD', label: 'Goad' },
        { id: 'GROUPHUG', label: 'Group Hug' },
        { id: 'SUPERFRIENDS', label: 'Super Friends' },
        { id: 'EXALTED', label: 'Exalted' },
    ],
    combo: [
        { id: 'combo', label: 'Combo' },
        { id: 'TURNS', label: 'Turns' },
        { id: 'ARISTOCRATS', label: 'Aristocrats' },
        { id: 'WHEELS', label: 'Wheels' },
        { id: 'MILL', label: 'Mill' },
        { id: 'STORM', label: 'Storm' },
        { id: 'SPELLSLINGER', label: 'Spell Slinger' },
    ],
};

export const getArchetypeMinorsForMajor = (major) => {
    if (!major || major === 'any') {
        return [{ id: 'any', label: 'Any' }, ...Object.values(ARCHETYPE_MINORS_BY_MAJOR).flat()];
    }
    return [{ id: 'any', label: 'Any' }, ...(ARCHETYPE_MINORS_BY_MAJOR[major] || [])];
};
